import React from 'react';
import Loading from '../../../components/loading/loading';
import ErrorBoundary from '../../../components/RootErrorBoundary';
import { useRecordingAsset } from '../../../queries/ats/recordings/hooks';
import { DetailsContextProvider } from '../details-context';
import { DetailsView } from '../details-view/details-view';
import { useDetailsParams } from '../utils';
import { DetailsViewLoaderProps } from './details-view-loader';
import { DetailsViewWrapper } from './details-view-wrapper';

interface RecordingDetailsViewLoaderProps extends Omit<DetailsViewLoaderProps, 'type'> {}

export function RecordingDetailsViewLoader({
  id,
  orderByProviderId,
  orderByServiceType,
  before,
  after,
}: RecordingDetailsViewLoaderProps) {
  const params = useDetailsParams();

  if (params.subType === undefined) {
    throw new Error(
      'RecordingDetailsViewLoader must be used within a Route with a path that includes "/details/recording/:subType/:id"',
    );
  }

  const { data: asset, isLoading } = useRecordingAsset({
    id,
    type: params.subType,
    orderByProviderId,
    orderByServiceType,
  });

  if (isLoading) {
    return (
      <DetailsViewWrapper asset={asset} before={before} after={after}>
        <Loading size={64} fadeIn contained />
      </DetailsViewWrapper>
    );
  }

  if (asset === undefined) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(`No series asset found for id: ${id}`);
    }

    return null;
  }

  return (
    <ErrorBoundary>
      <DetailsViewWrapper asset={asset} before={before} after={after}>
        <DetailsContextProvider asset={asset}>
          <DetailsView asset={asset} />
        </DetailsContextProvider>
      </DetailsViewWrapper>
    </ErrorBoundary>
  );
}
